import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForCheckInBefore_00days = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtCheckInBefore00Days($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtCheckInBefore00Days(input: $input) {
			userErrors
			success
		}
	}
`);
